<template>
  <v-app-bar class="header-shell-desktop" color="primary" height="220">
    <div class="w-100">
      <v-container class="py-0">
        <SocialWidget class="ml-auto" />
        <div class="header-shell-desktop_center pb-9">
          <LogoWidget :height="mdAndDown ? 60 : 83" />
          <BannerWidget type="carousel" category="Full Banner" />
        </div>
      </v-container>
      <v-divider class="secondary"></v-divider>
      <v-container class="py-0 d-flex justify-space-between align-center">
        <MenuWidget />
        <SearchWidget />
      </v-container>
    </div>
  </v-app-bar>
</template>

<script>
import LogoWidget from "../../widgets/LogoWidget.vue";
import MenuWidget from "../../widgets/MenuWidget.vue";
import BannerWidget from "../../widgets/BannerWidget.vue";
import SearchWidget from "../../widgets/SearchWidget.vue";
import SocialWidget from "../../widgets/SocialWidget.vue";

export default {
  computed: {
    mdAndDown() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
  },
  components: {
    LogoWidget,
    MenuWidget,
    BannerWidget,
    SearchWidget,
    SocialWidget,
  },
};
</script>

<style lang="scss">
.header-shell-desktop {
  &_center {
    display: grid;
    grid-template-columns: auto 728px;
    align-items: center;
    gap: 16px;
  }

  .v-toolbar__content {
    padding: 0;
  }
}

@media screen and (max-width: 1264px) {
  .header-shell-desktop_center {
    grid-template-columns: auto 600px;
  }
}
</style>
